module.exports = __webpack_public_path__ + "static/img/noodle1.edec0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noodle/en/noodle1.jpg
// module id = QmQH
// module chunks = 1